export default __webpack_public_path__ + "static/media/ic_italy.5efb7c0e.svg";